import Container from "../Container";
import { Category } from "../../types";

interface CategoriesSectionProps {
  categories: Category[];
}

const CategoriesSection = ({ categories }: CategoriesSectionProps) => {
  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-gradient-to-b from-white to-muted/20 dark:from-gray-900 dark:to-gray-800">
      <Container>
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold mb-4">
            <span className="text-brand-gradient">Explora</span> por Categorías
          </h2>
          <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
            Encuentra exactamente lo que buscas navegando por nuestras categorías especializadas
          </p>
          <div className="mt-4 w-24 h-1 bg-brand-gradient rounded-full mx-auto" />
        </div>
        
        <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-8 gap-4">
          {categories.map((category, index) => (
            <a
              key={category.id}
              href={`/products/${category.slug}`}
              className="group relative flex flex-col items-center justify-center p-6 rounded-2xl bg-white/60 dark:bg-gray-800/60 glass-effect border border-brand-neutral/20 transition-all duration-300 hover-lift hover:shadow-brand"
              style={{
                animationDelay: `${index * 100}ms`,
                animation: 'fadeInUp 0.6s ease-out both'
              }}
            >
              {/* Icon/Avatar Circle */}
              <div className="w-16 h-16 mb-4 rounded-full bg-brand-gradient flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <span className="text-2xl font-bold text-black">
                  {category.name.charAt(0).toUpperCase()}
                </span>
              </div>
              
              {/* Category Name */}
              <span className="text-sm font-semibold text-center leading-tight text-foreground group-hover:text-brand-primary transition-colors duration-300">
                {category.name}
              </span>
              
              {/* Hover Arrow */}
              <div className="mt-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <svg className="w-4 h-4 text-brand-secondary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                </svg>
              </div>

              {/* Hover glow effect */}
              <div className="absolute inset-0 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300 bg-gradient-to-r from-brand-primary/10 to-brand-secondary/10 pointer-events-none" />
            </a>
          ))}
        </div>


      </Container>
    </section>
  );
};

export default CategoriesSection;